<script lang="ts">
  // Eight placeholder rows while the first sync or search is running (spec §9 item 7).
  const ROWS = [0, 1, 2, 3, 4, 5, 6, 7];
</script>

<div class="skeleton" aria-hidden="true">
  {#each ROWS as i (i)}
    <div class="sk-row"><span class="sk dot"></span><span class="sk l1"></span><span class="sk l2"></span></div>
  {/each}
</div>

<style>
  /* @css list/Skeleton start */
  .skeleton {
    padding-top: 2px
  }

  .sk-row {
    height: var(--row-h, 76px);
    display: flex;
    align-items: center;
    gap: var(--space-3);
    padding-inline: var(--space-4);
    border-bottom: 1px solid var(--border-subtle);
    animation: svelte-kpj0wp-pulse 1.1s var(--ease-standard) infinite alternate
  }

  .sk {
    background: var(--surface-sunken);
    border-radius: var(--radius-xs)
  }

  .sk.dot {
    width: var(--control-md);
    height: var(--control-md);
    border-radius: var(--radius-pill);
    flex: none
  }

  .sk.l1 {
    width: 26%;
    height: 12px
  }

  .sk.l2 {
    width: 46%;
    height: 12px
  }

  @keyframes svelte-kpj0wp-pulse {
    0% {
      opacity: .55
    }

    to {
      opacity: 1
    }
  }
  /* @css list/Skeleton end */
</style>
